import { SensoterraMoistureSensorAPI } from "../../APICommands/index.js";
import { findEventually } from "../AMasterIndex.js";
import { DeviceBase } from "./DeviceBase.js";
import { DeviceWarning } from "./Warnings.js";

export class SensoterraMoistureSensor extends DeviceBase {
    zone = undefined;
    category = "SensoterraMoisture";
    depth = undefined;
    soilType = undefined;
    acceptableValueRange = [];
    /**
     *
     * @type {{value: number, date: Date}}
     */
    lastDataPoint = undefined;
    /**
     *
     * @type {string}
     */
    enclosureID = "";
    /**
     * Creates a new entity of this type and sends it to the server. When the server accepts the new entity, a new local entity
     * is created and this function returns.
     * @constructor
     * @param {String} EnclosureID the SerialNumber on the probe
     * @param {Number} lat
     * @param {Number} long
     * @param {String} zone
     * @param {Number} depth (in inches)
     * @param {String} soilType
     * @param {String} label
     * @param {String} userId dbID of user
     * @return {Promise<ModelBase>}
     */
    static async createNew(EnclosureID, lat, long, zone, depth, soilType, label) {
        return await SensoterraMoistureSensorAPI.addOne(EnclosureID, lat, long, zone, depth, soilType, label).then(
            (r) => new SensoterraMoistureSensor(r),
        );
    }
    /**
     *
     * @type {{date: Date, moistureReading: number}[]}
     */
    soilMoistureHistory;
    constructor(json) {
        super(json);
        try {
            if (json.warnings) {
                this.warnings = json.warnings.map((w) => new DeviceWarning(w));
            }
        } catch (e) {
            console.warn(e);
        }
        this.category = "SensoterraMoisture";
        this.dbID = json._id;
        this.name = json.name || json.label || json.node_id;
        this.label = json.label;
        this.lat = json.latitude || this.lat;
        this.long = json.longitude || this.long;
        this.createdAt = new Date(json.createdAt);
        if (json.EnclosureID) {
            this.enclosureID = json.EnclosureID;
        }
        this.acceptableValueRange = json.acceptableValueRange || [-1, 100];

        if (json.enclosureID) {
            this.enclosureID = json.enclosureID;
        }
        this.soilMoistureHistory = json.soilMoistureHistory;
        this.history = json.history;
        this.depth = json.depth;
        this.device_stats = json.deviceStats || {};
        this.device_stats.batt = json.RunningAverageVoltage;

        if (json.status) {
            if (json.status.toLowerCase() === "active") {
                this.status = "stand by";
            } else if (json.status.toLowerCase() === "error") {
                this.status = "error";
            } else {
                this.status = json.status;
            }
        } else {
            this.status = "idle";
        }
        if (json.DeviceType) {
            this.type = json.DeviceType;
        } else {
            this.type = "msense";
        }

        this.load(json)
            .then(() => {
                if (this.recentData["moisture"]) {
                    this.lastDataPoint = this.recentData["moisture"];
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    async load(json) {
        const temp = json.zone;
        if (temp) {
            await findEventually("zone", temp, 6000)
                .then((r) => {
                    this.zone = r;
                    if (r.moistureSensors) {
                        r.moistureSensors.push(this);
                    }
                    r.devices.push(this);
                })
                .catch(() => {
                    console.warn(`Zone ${temp} not found or not loaded`);
                });
        }
        await super.load();
    }

    /**
     *
     * @param  {{latitude: number, longitude: number, zone : string, name: string, depth: number}} args
     * @returns {Promise<void>}
     */ // @ts-ignore
    async edit(args) {
        const json = await SensoterraMoistureSensorAPI.editOne(this.id, args);
        // @ts-ignore
        if (this.zone?.id?.toString() !== json.zone?.toString()) {
            if (this.zone) {
                this.zone.devices = this.zone.devices.filter((d) => d !== this);
                if (this.zone.moistureSensors) {
                    this.zone.moistureSensors = this.zone.moistureSensors.filter((d) => d !== this);
                }
            } // @ts-ignore
            const temp = json.zone;
            await findEventually("zone", temp)
                .then((r) => {
                    this.zone = r;
                    r.moistureSensors.push(this);
                    r.devices.push(this);
                })
                .catch(() => {
                    console.warn(`Zone ${temp} not found or not loaded`);
                });
        } // @ts-ignore
        this.name = json.name || json.label || json.node_id;
        // @ts-ignore
        this.label = json.label;
        // @ts-ignore
        this.lat = json.latitude || this.lat;
        // @ts-ignore
        this.long = json.longitude || this.long;
        // @ts-ignore
        this.acceptableValueRange = json.acceptableValueRange || [-1, 100] || this.acceptableValueRange;
        this.onChange.trigger({});
    }
    /**
     * Deletes this entity and returns when the entity has been deleted from the server.
     */
    async delete() {
        await SensoterraMoistureSensorAPI.deleteOne(this.id).then(() => {
            super.delete();
        });
    }
}
